<template>
  <div>
    <div class="columns">
      <div class="column">
        DashboardOperator
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'DashboardOperator',
    props: {},
    data () {
      return {}
    },
    computed: {}
  }
</script>

<style>


</style>



// WEBPACK FOOTER //
// src/components/home/DashboardOperator.vue